/* eslint-disable prettier/prettier */
/**
 * Defines one color for every day of the year in a 2D array with the following zero-based indexes:
 * 	DAILY_COLORS[month:0..11][day: 0..30]
 * Example: The statement returns the color for January 31st after adjusting the array index with -1:
 * 	let color = DAILY_COLORS[1-1][31-1];
 */
export const DAILY_COLORS = [
	[
		"#4ea1df",
		"#2689d2",
		"#185684",
		"#2d90d9",
		"#5ba8e1",
		"#479ede",
		"#13456a",
		"#1a5e91",
		"#3494da",
		"#54a5e0",
		"#113d5d",
		"#1c679e",
		"#227cbe",
		"#144970",
		"#419bdd",
		"#2584cb",
		"#278dd8",
		"#17527d",
		"#154d77",
		"#2074b1",
		"#68afe4",
		"#1f6fab",
		"#2380c5",
		"#1e6ba4",
		"#195a8a",
		"#3a97dc",
		"#6eb3e5",
		"#61ace3",
		"#124163",
		"#1b6397",
		"#2178b8",
	],
	[
		"#788f9e",
		"#8196a4",
		"#c4ced4",
		"#546875",
		"#adbbc4",
		"#b2bfc8",
		"#4b5c68",
		"#516471",
		"#5b707e",
		"#617887",
		"#6f8897",
		"#688090",
		"#bfcad1",
		"#8ea2ae",
		"#93a5b1",
		"#859aa8",
		"#748b9b",
		"#647c8b",
		"#b6c3cb",
		"#4e606c",
		"#97a9b4",
		"#a9b8c1",
		"#a5b4be",
		"#5e7483",
		"#bbc6ce",
		"#9cadb8",
		"#a0b0bb",
		"#6b8494",
		"#576c7a",
		"#7c93a1",
		"#8a9eab",
	],
	[
		"#4361ae",
		"#7991cb",
		"#5e7ac1",
		"#324881",
		"#7f95cd",
		"#748cc9",
		"#273966",
		"#2e4276",
		"#385292",
		"#3d589d",
		"#30457c",
		"#4564b3",
		"#3b5597",
		"#90a3d4",
		"#849ad0",
		"#637ec3",
		"#6e87c7",
		"#253660",
		"#4d6cba",
		"#4867b8",
		"#6983c5",
		"#5371bc",
		"#8a9ed2",
		"#344b87",
		"#2a3c6b",
		"#3f5ba2",
		"#5875bf",
		"#2c3f71",
		"#23335b",
		"#415ea8",
		"#364f8c",
	],
	[
		"#295168",
		"#7dafcc",
		"#98c0d6",
		"#5194ba",
		"#5c9bbf",
		"#32627e",
		"#2f5e78",
		"#2b556d",
		"#346783",
		"#2d5a73",
		"#366b89",
		"#478db4",
		"#274d62",
		"#386f8e",
		"#3f7c9f",
		"#67a2c3",
		"#3c7899",
		"#77acc9",
		"#88b6d0",
		"#4b91b8",
		"#5698bc",
		"#4385aa",
		"#8db9d2",
		"#72a9c7",
		"#4589af",
		"#619ec1",
		"#93bdd4",
		"#4180a4",
		"#82b3ce",
		"#3a7494",
		"#6ca5c5",
	],
	[
		"#3f5b1a",
		"#a2d262",
		"#69972b",
		"#9bcf57",
		"#add774",
		"#507321",
		"#587f24",
		"#608b28",
		"#b0d97a",
		"#3b5518",
		"#71a22f",
		"#91ca45",
		"#9fd05d",
		"#7db434",
		"#8ac639",
		"#5c8526",
		"#a9d56e",
		"#43611c",
		"#48671e",
		"#64912a",
		"#a6d468",
		"#4c6d1f",
		"#6d9d2d",
		"#85c037",
		"#547923",
		"#98cd51",
		"#79ae32",
		"#75a830",
		"#81ba35",
		"#8dc83f",
		"#94cb4b",
	],
	[
		"#74a9dc",
		"#6ea6da",
		"#317cc3",
		"#266198",
		"#255d92",
		"#80b1df",
		"#86b5e1",
		"#498fd1",
		"#28659e",
		"#205180",
		"#2b6cab",
		"#619ed7",
		"#68a2d9",
		"#5597d4",
		"#3784cd",
		"#1b466d",
		"#3380c9",
		"#2e74b7",
		"#4f93d3",
		"#2c70b1",
		"#438bd0",
		"#225586",
		"#23598c",
		"#2f78bd",
		"#8cb8e2",
		"#2969a4",
		"#1f4d7a",
		"#7aadde",
		"#1d4974",
		"#3d87ce",
		"#5b9ad6",
	],
	[
		"#59dba9",
		"#6cdfb3",
		"#145a3f",
		"#2ccb8e",
		"#73e1b6",
		"#2dd292",
		"#1e8c62",
		"#239f6f",
		"#40d69c",
		"#60dcac",
		"#3ad499",
		"#166748",
		"#197351",
		"#4dd8a3",
		"#34d396",
		"#25ac78",
		"#2bc58a",
		"#53daa6",
		"#47d79f",
		"#186d4c",
		"#1a7a55",
		"#21996b",
		"#29bf85",
		"#156043",
		"#209367",
		"#28b881",
		"#66deb0",
		"#27b27c",
		"#24a674",
		"#1c8059",
		"#1d865e",
	],
	[
		"#e68112",
		"#ad610d",
		"#ed8512",
		"#f2aa59",
		"#d87910",
		"#c9710f",
		"#f09b3d",
		"#f09836",
		"#744109",
		"#f2a652",
		"#f19f44",
		"#ed8919",
		"#98550c",
		"#ef9027",
		"#9f590c",
		"#7b4509",
		"#663908",
		"#df7d11",
		"#ee8d20",
		"#d07510",
		"#bb690e",
		"#894d0a",
		"#b4650e",
		"#6d3d08",
		"#82490a",
		"#ef942f",
		"#f1a24b",
		"#f3ad60",
		"#91510b",
		"#c26d0f",
		"#a65d0d",
	],
	[
		"#a98174",
		"#cfb9b2",
		"#cab0a8",
		"#94695b",
		"#735147",
		"#bb9a91",
		"#906558",
		"#6e4e44",
		"#c4a79f",
		"#ccb4ad",
		"#9e6f61",
		"#865f53",
		"#b28d82",
		"#c1a39a",
		"#a77c6f",
		"#d8c6c0",
		"#ac8579",
		"#af897e",
		"#8b6256",
		"#be9f95",
		"#a4786b",
		"#d2bdb6",
		"#b8968c",
		"#d5c1bb",
		"#78554a",
		"#b59287",
		"#7d584d",
		"#c7aca3",
		"#996c5e",
		"#a17466",
		"#815b50",
	],
	[
		"#99511a",
		"#784014",
		"#c76921",
		"#7f4315",
		"#e69e66",
		"#c06620",
		"#a0551b",
		"#ad5c1d",
		"#a6581c",
		"#5e3210",
		"#854716",
		"#dc782b",
		"#e18d4c",
		"#723c13",
		"#8c4a17",
		"#b35f1e",
		"#cd6d22",
		"#d47023",
		"#924e18",
		"#e08945",
		"#db7424",
		"#e7a26d",
		"#6b3912",
		"#653511",
		"#e39559",
		"#dd7c32",
		"#df853f",
		"#ba631f",
		"#e4995f",
		"#de8038",
		"#e29152",
	],
	[
		"#9e98b5",
		"#aaa5be",
		"#aea9c1",
		"#80789e",
		"#5b5576",
		"#847da1",
		"#585171",
		"#8d86a8",
		"#7c749b",
		"#4a455f",
		"#a29cb8",
		"#a6a0bb",
		"#625b7e",
		"#8981a5",
		"#696187",
		"#918aab",
		"#544e6d",
		"#6d658c",
		"#746b95",
		"#bfbbce",
		"#787098",
		"#706890",
		"#958fae",
		"#514b68",
		"#b3aec5",
		"#9993b1",
		"#bbb7cb",
		"#b7b2c8",
		"#5f587a",
		"#4e4864",
		"#665e83",
	],
	[
		"#1a307a",
		"#203c9a",
		"#4c6cd9",
		"#162867",
		"#2341a6",
		"#395dd5",
		"#5272db",
		"#284bc0",
		"#2646b3",
		"#3f62d7",
		"#4667d8",
		"#1c3587",
		"#1f3a94",
		"#1b3281",
		"#182d74",
		"#6581df",
		"#142661",
		"#2c52d3",
		"#728be1",
		"#2749b9",
		"#223fa0",
		"#2b50cc",
		"#172b6e",
		"#2444ad",
		"#3358d4",
		"#1e378d",
		"#5f7cdd",
		"#2a4ec6",
		"#13235b",
		"#5977dc",
		"#6b86e0",
	],
];
